export const TOOL_TYPES = {
  ENTITY_LOOKUP: 'entity_lookup',
  FORM: 'form',
}

export const TOOL_TYPE_LABELS = {
  [TOOL_TYPES.ENTITY_LOOKUP]: 'Lookup',
  [TOOL_TYPES.FORM]: 'Auto Capture',
}

export const TOOL_SOURCES = {
  WEB: 'web',
  SHAREPOINT: 'sharepoint',
}

export const TOOL_SOURCE_LABELS = {
  [TOOL_SOURCES.WEB]: 'Web',
  [TOOL_SOURCES.SHAREPOINT]: 'Knowledge Base',
}

export const TOOL_SPEAKERS = {
  PER_FIELD: '',
  CUSTOMER: 'customer',
  AGENT: 'agent',
  BOTH: 'both',
}

export const TOOL_SPEAKER_LABELS = {
  [TOOL_SPEAKERS.PER_FIELD]: 'Per field',
  [TOOL_SPEAKERS.CUSTOMER]: 'Customer',
  [TOOL_SPEAKERS.AGENT]: 'Agent',
  [TOOL_SPEAKERS.BOTH]: 'Both',
}

export const TOOL_REVEALS = {
  FULL: 'full',
  LAST4: 'last4',
  NONE: 'none',
}

export const TOOL_REVEAL_LABELS = {
  [TOOL_REVEALS.FULL]: 'Full value',
  [TOOL_REVEALS.LAST4]: 'Last 4 only',
  [TOOL_REVEALS.NONE]: 'Hidden',
}

const toOptions = (labels) => Object.entries(labels).map(([value, label]) => ({ value, label }))

export const toolTypeOptions = toOptions(TOOL_TYPE_LABELS)
export const toolSourceOptions = toOptions(TOOL_SOURCE_LABELS)
export const toolSpeakerDefaultOptions = toOptions(TOOL_SPEAKER_LABELS)
export const toolSpeakerOptions = toolSpeakerDefaultOptions.filter(
  (option) => option.value !== TOOL_SPEAKERS.PER_FIELD
)
export const toolRevealOptions = toOptions(TOOL_REVEAL_LABELS)

export const KNOWLEDGE_BASE_UNAVAILABLE_MESSAGE =
  'The knowledge base requires AI Answers to be enabled for this organization.'
export const LEGACY_ENTITY_PLACEHOLDER_PROMPT =
  'Not used: entity_lookup tool results come from entity-tools.'

export const ENTITY_TYPES = {
  MEDICINE: 'medicine',
  VEHICLE: 'vehicle',
}

export const DEFAULT_LOOKUP_ENTITY_TYPE = ENTITY_TYPES.MEDICINE
export const LOOKUP_QUESTION_VARIABLES = ['name', 'entity_type']
export const lookupVariable = (name) => ['$', '{', name, '}'].join('')
export const DEFAULT_LOOKUP_QUESTION = `Look up the ${lookupVariable('entity_type')} "${lookupVariable('name')}".`
export const DEFAULT_LOOKUP_INSTRUCTIONS =
  'Answer for a call center agent in plain language. Start with a one-line summary, then up to 4 short bullets with the key facts. Keep it under 120 words and cite the source.'

export const LOOKUP_QUESTION_DEFAULTS = {
  [ENTITY_TYPES.MEDICINE]: `What is ${lookupVariable('name')} prescribed for, how is it taken, and what are its common side effects?`,
  [ENTITY_TYPES.VEHICLE]: `What are the key specs, trim levels, and open recalls for the ${lookupVariable('name')}?`,
}

export const LOOKUP_INSTRUCTIONS_PLACEHOLDER =
  'e.g. Start with a one-line summary, then up to 4 short bullets, and cite the source'

export const TOOL_CONFIG_VERSION_KEY = 'version'
export const TOOL_FIELD_KEY_MAX_LENGTH = 48
export const TOOL_FIELD_FALLBACK_TYPE = 'free_text'

export const DEFAULT_TOOL_FIELD_LIMITS = {
  fields: 24,
  values: 32,
  label_tokens: 12,
  description_tokens: 40,
}
